import timberBIWrappers from './wrappers/timberBIWrappers';
import timberWrappers from './wrappers/timberWrappers';

export const timberWrapperService = {
  timber: timberWrappers,
  instrumentation: timberBIWrappers,
};
